module.exports = __webpack_public_path__ + "img/symbol_3.db0e286e.png";